import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'

type OpportunityData = PildomModules.Voirie.Data.OpportunityData

export class Like extends BaseModel<any> {
    endPoint: string = 'voirie/opportunities/{opportunity}/likes'
    translationKey: string = 'voirie.likes'
    permissionName: string = 'voirie_like'
    public opportunity: OpportunityData

    setOpportunity(opportunityData: OpportunityData): Like {
        this.opportunity = opportunityData
        return this
    }

    getEndPoint(useEntityId: boolean = false): string {
        const baseEndPoint = this.endPoint.replace('{opportunity}', this.opportunity.id)
        if (useEntityId)
            return `${baseEndPoint}/${this.getKey()}`
        return baseEndPoint
    }
}
